module.exports = __webpack_public_path__ + "img/test4.f96004fa.png";